import Joi from "joi";
import { Group } from "../../../graphql/generated";

const groupSchema = Joi.object<Group>({
  name: Joi.string().required().label("Name"),
  memberIds: Joi.array().items(Joi.string()).required().label("Members"),
  defaultFromReceiverForOrders: Joi.boolean()
    .optional()
    .label("Default from Receiver for orders"),
});

export default groupSchema;
